<label class="form-label d-block" [ngClass]="{'doc-body-2': boldLabel}">{{label}}</label>
<div class="w-100 mb-2 dateTimeWrapper" [ngClass]="{'mt-0': dateOnly}">
    <mat-form-field appearance="outline" floatLable="never" class="doc-custom-input dateWrapper"
        [ngClass]="{'d-none': timeOnly}" (click)="picker.open()">
        <input readonly matInput [matDatepicker]="picker" placeholder="TT.MM.JJJJ" [ngModel]="value"
            [disabled]="disabled" (dateChange)="dateChange('change',$event)" [min]="getMinimumDate()">
        <mat-datepicker-toggle matSuffix [for]="picker">
            <mat-icon matDatepickerToggleIcon>
                <i class="fi-rr-calendar"></i>
            </mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #picker [startView]="startView" [startAt]="startAt"></mat-datepicker>
        <mat-hint>
            <doc-form-field-error [parentForm]="parentForm" [controlName]="controlName"></doc-form-field-error>
        </mat-hint>
    </mat-form-field>

    <div class="doc-custom-input timeWrapper mb-3 doc-custom-time" [ngClass]="{'d-none': dateOnly}">
        <div class="hourWrapper">
            <mat-form-field appearance="outline" class="doc-custom-input w-100" style="padding-left: 0 !important;">
                <mat-select [(value)]="hour" (selectionChange)="selectionChanged($event)" [disabled]="disabled">
                    <mat-option *ngFor="let hour of hours" [value]="hour"> {{hour}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <span class="seperator">:</span>
        <div class="minWrapper">
            <mat-form-field appearance="outline" class="doc-custom-input w-100" style="padding-left: 0 !important;">
                <mat-select [(value)]="minute" (selectionChange)="selectionChanged($event)" [disabled]="disabled">
                    <mat-option *ngFor="let minute of getMinutes()" [value]="minute"> {{minute}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
</div>